<template>
  <div class="container centering text-center pt-9">
    <img class="d-block mb-9 mx-auto" src="@/assets/images/home/welcome.svg" />
    <h5>Bem-vindo(a) a área de membros do seu produto</h5>
    <div class="text-secondary mb-9">
      Para começar, cadastre o seu primeiro conteúdo.
    </div>
    <b-dropdown
      right
      offset="48"
      text="Right align"
      class="btn btn-sm btn-40 btn-primary p-0"
    >
      <template #button-content>
        <div class="d-flex justify-content-between align-items-center">
          <span class="pr-5">Novo módulo ou avaliação</span>
          <i class="icon-angle-down fs-16"></i>
        </div>
      </template>
      <b-dropdown-item>
        <router-link
          class="text-dark"
          :to="{
            name: 'product-members-module-add',
            params: { id: $route.params.id }
          }"
        >
          Novo módulo em branco
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item>
        <router-link
          class="text-dark"
          :to="{
            name: 'product-members-module-quizz-final-add',
            params: { id: $route.params.id }
          }"
        >
          Nova avaliação final
        </router-link>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
a,
a:hover {
  text-decoration: none;
}
</style>
